import type { OptionColor, StatusGroup } from "@bundle/contracts";
import { Icon, Stack, Text } from "../../primitives/index.ts";
import { tagBackground, tagForeground } from "./labels.ts";

export type TagProps = {
  name: string;
  color: OptionColor;
  /** Status options show their group as a leading glyph (to-do / in progress / complete). */
  statusGroup?: StatusGroup;
  testID?: string;
};

/** A select / multi-select / status option chip in its colour (`tag.<color>` tokens). */
export function Tag({ name, color, statusGroup, testID }: TagProps) {
  return (
    <Stack direction="horizontal" align="center" gap="1" paddingX="1.5" radius="sm" background={tagBackground(color)} testID={testID}>
      {statusGroup === undefined ? null : (
        <Icon name={statusGroup === "complete" ? "checkCircle" : statusGroup === "in_progress" ? "inProgress" : "status"} size="icon.sm" color={tagForeground(color)} />
      )}
      <Text variant="footnote" color={tagForeground(color)} lines={1}>
        {name}
      </Text>
    </Stack>
  );
}
